import { IntegrationServiceId } from '../../common/integrations'
import { isCompleteLinkFor } from '../../common/contactLinks'
import { Account, CRMAccountIntegrationConfig } from '../../models/Account'

export type IntegrationFieldType = 'text' | 'textarea' | 'number' | 'date' | 'reference'

export interface IntegrationObjectFieldConfig {
  apiName: string
  label: string
  description: string
  type: IntegrationFieldType
  options?: string[]
  referenceObjectName?: string
}

export interface MappedIntegrationObject {
  serviceId: IntegrationServiceId
  objectName: string
  displayName: string
  contactRequired: boolean
  allowCreate: boolean
  allowUpdate: boolean
  referenceFields: string[]
}

const mapIntegrationObjectEntries = (integrationConfig: CRMAccountIntegrationConfig): MappedIntegrationObject[] => {
  const entries = integrationConfig.mappings?.customObjects ?? []
  const connector = integrationConfig.serviceId as IntegrationServiceId
  return entries
    .filter((entry) => !!entry?.objectName)
    .map((entry) => ({
      serviceId: connector,
      objectName: entry.objectName,
      displayName: entry.displayName || entry.objectName,
      contactRequired: !!entry.contactLinkField || (entry.contactLinks ?? []).some((link) => isCompleteLinkFor(link, entry.objectName)),
      allowCreate: true,
      allowUpdate: true,
      referenceFields: entry.referenceFields ?? [],
    }))
}

export const getMappedIntegrationObjects = (account: Account | undefined): MappedIntegrationObject[] => {
  const crmIntegrations = (account?.config.integrations.filter((i) => i.type === 'crm') ?? []) as CRMAccountIntegrationConfig[]
  return crmIntegrations.flatMap(mapIntegrationObjectEntries)
}

const BASE_OBJECT_PREFIX = 'crm_object_record'
const LIST_OBJECT_PREFIX = 'crm_object_records'

export const integrationObjectRoutingKey = (kind: 'list' | 'single' | 'create' | 'update' | 'schema', objectName: string): string => {
  if (kind === 'list') {
    return `${LIST_OBJECT_PREFIX}|${objectName}`
  }
  if (kind === 'single') {
    return `${BASE_OBJECT_PREFIX}|${objectName}`
  }
  return `${kind}|${BASE_OBJECT_PREFIX}|${objectName}`
}
